<vg-loader></vg-loader>
<!--<vg-heroku-wakeup-new [configList]="endpointMap" [templateRef]="main" [interactTimeout]="1800000"></vg-heroku-wakeup-new>-->
<!--<ng-template #main>-->
<!--  <router-outlet></router-outlet>-->
<!--</ng-template>-->
<router-outlet></router-outlet>
